// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-title__header[data-v-a3836060]{margin-bottom:10px}.page-title__header--level-1[data-v-a3836060]{text-transform:uppercase}.page-title__buttons[data-v-a3836060]{display:flex;flex-flow:row wrap;margin-bottom:20px}.page-title__button[data-v-a3836060]{align-items:center;color:#0f73ee;display:flex;padding:10px 0}.page-title__button[data-v-a3836060]:hover{cursor:pointer}.page-title__alert[data-v-a3836060]{margin-bottom:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
